import { render, staticRenderFns } from "./brandDetail.vue?vue&type=template&id=31a3e591&scoped=true"
import script from "./brandDetail.vue?vue&type=script&lang=js"
export * from "./brandDetail.vue?vue&type=script&lang=js"
import style0 from "./brandDetail.vue?vue&type=style&index=0&id=31a3e591&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a3e591",
  null
  
)

export default component.exports